import { render } from "./Notes1.vue?vue&type=template&id=ace8cf14&scoped=true"
import script from "./Notes1.vue?vue&type=script&lang=js"
export * from "./Notes1.vue?vue&type=script&lang=js"

import "./Notes1.vue?vue&type=style&index=0&id=ace8cf14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace8cf14"]])

export default __exports__